import { render, staticRenderFns } from "./InspectionView.vue?vue&type=template&id=127a28e9&"
import script from "./InspectionView.vue?vue&type=script&lang=js&"
export * from "./InspectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports